import React from 'react';
import { ArrowRight } from 'lucide-react';
import useIntersectionObserver from '../../hooks/useIntersectionObserver';
import { AntennaSignal, TerminalCursor, CodeTags, Microchip, CloudOutline } from '../../components/Doodle/Doodle';
import { IsoCube, IsoShield } from '../../components/Svg3D/Svg3D';
import styles from './Contact.module.css';

const packages = [
  {
    title: 'Discovery Sprint',
    description: '2-week assessment of your biggest bottleneck. Walk away with a prioritized roadmap.',
  },
  {
    title: 'Proof of Value',
    description: '4-week pilot on a real use case. Measurable results before you commit.',
  },
  {
    title: 'Full Engagement',
    description: 'Embedded team, shared accountability, production delivery at scale.',
  },
];

const Contact = ({ onOpenForm }) => {
  const [sectionRef, isVisible] = useIntersectionObserver({ threshold: 0.1, triggerOnce: true });

  return (
    <section
      id="contact"
      className={`${styles.section} grid-bg`}
      ref={sectionRef}
    >
      <AntennaSignal position={{ top: '8%', right: '3%' }} size={140} theme="light" opacity={0.18} className={styles.doodle} />
      <TerminalCursor position={{ bottom: '6%', left: '2%' }} size={130} theme="light" opacity={0.16} className={styles.doodle} />
      <CodeTags position={{ top: '5%', left: '2%' }} size={120} theme="light" opacity={0.14} className={styles.doodle} />
      <Microchip position={{ bottom: '10%', right: '3%' }} size={110} theme="light" opacity={0.13} className={styles.doodle} />
      <CloudOutline position={{ top: '45%', right: '1%' }} size={150} theme="light" opacity={0.15} className={styles.doodle} />
      <IsoCube position={{ top: '30%', left: '6%' }} size={140} opacity={0.45} />
      <IsoShield position={{ bottom: '22%', left: '5%' }} size={150} opacity={0.4} />
      <div className="container">
        <div className={`${styles.content} ${isVisible ? styles.visible : ''}`}>
          <h2 className={styles.title}>
            Stop Planning. Start Shipping.
          </h2>
          <p className={styles.subtitle}>
            Tell us where you're stuck. We'll show you how fast we can move.
          </p>

          <div className={styles.cards}>
            {packages.map((pkg) => (
              <div key={pkg.title} className={styles.card}>
                <h3 className={styles.cardTitle}>{pkg.title}</h3>
                <p className={styles.cardDesc}>{pkg.description}</p>
              </div>
            ))}
          </div>

          <div className={styles.ctaRow}>
            <button
              className="bracket-btn bracket-btn--light"
              onClick={onOpenForm}
            >
              Start a Conversation
              <ArrowRight size={18} />
            </button>
            <a href="mailto:info@blueprintx.net" className={styles.emailLink}>
              info@blueprintx.net
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
